
import { Component, Vue, Prop} from 'vue-property-decorator';
import { namespace } from "vuex-class";  

import PageBase from "../../PageBase.vue";
import CreditorInfo from './CreditorInfo.vue';
import CreditorOrgInfo from './CreditorOrgInfo.vue';
import Tooltip from "@/components/survey/Tooltip.vue";
 
import "@/store/modules/application";
const applicationState = namespace("Application");

import { stepInfoType, stepResultInfoType } from "@/types/Application";
import { stepsAndPagesNumberInfoType } from "@/types/Application/StepsAndPages";
import { nameInfoType } from '@/types/Common';
import { creditorPersonInfoType } from '@/types/Application/Creditor';

@Component({
    components:{
      CreditorInfo,
      CreditorOrgInfo,
      PageBase,
      Tooltip
    }
})
export default class Creditors extends Vue {

    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.State
    public deceasedName!: nameInfoType;

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    currentStep =0;
    currentPage =0;

    showOrgTable = true;
    creditorData = [];
    creditorOrgData = [];
    relativesList = [];
   
    incompleteError =  false;  
    incompleteOrgError =  false; 
    creditorPersonExists = null; 
    creditorOrgExists = null; 
    creditorCompleted = null;
    updated = 0;
    updatedOrg = 0;
    updatedCreditors = 0;
    showLessMoneyInfo = false;     

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        if(!this.incompleteError && !this.incompleteOrgError)    
            Vue.prototype.$UpdateGotoNextStepPage()
    }

    created() {

        if (this.step.result?.creditorPersonExists) {
            this.creditorPersonExists = this.step.result.creditorPersonExists;
        }

        if (this.step.result?.creditorSurvey?.data)
            this.creditorData = this.step.result.creditorSurvey.data;

        if (this.step.result?.creditorOrgSurvey?.data)
            this.creditorOrgData = this.step.result.creditorOrgSurvey.data;
        
        if (this.step.result?.creditorOrgExists) {
            this.creditorOrgExists = this.step.result.creditorOrgExists;
        }        

        if (this.step.result?.creditorCompleted) {
            this.creditorCompleted = this.step.result.creditorCompleted;
        }   
    }

    mounted(){
        this.updated = 0;
        this.updatedOrg = 0;
        this.updatedCreditors = 0;
        this.relativesList = Vue.filter('getRelatedPeopleInfo')(this.step, false, false, true, false, false);
        Vue.nextTick(()=>this.surveyHasError());
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;        
    }

    public surveyHasError(){
        let progress = (this.creditorData?.length==0 && this.creditorOrgData?.length==0)? 50 : 100;
        
        if(this.creditorPersonExists == 'No' && this.creditorOrgExists == 'No' && this.creditorCompleted == 'Yes') progress =100;

        this.incompleteError =  false;        
        //TODO: update with data coming from the components    
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }
    
    public isDisableNext() {
        return (this.creditorPersonExists == null || (this.creditorPersonExists == 'Yes' && this.creditorData?.length <= 0 ) || 
            !this.creditorCompleted || this.creditorCompleted == 'No' ||
            this.creditorOrgExists == null || (this.creditorOrgExists == 'Yes' && this.creditorOrgData?.length <= 0 ));
    }

    public creditorChange(creditorList,type){               
        if(type=='org') this.creditorOrgData = creditorList;
        else this.creditorData = creditorList;
    }

    beforeDestroy() {
        this.surveyHasError();  
        
        let creditorInfo = this.getCreditorResults();               
        if(this.creditorPersonExists == 'No')  creditorInfo = null

        let creditorOrgInfo = this.getCreditorOrgResults();               
        if(this.creditorOrgExists == 'No')  creditorOrgInfo = null


        this.UpdateStepResultData({step:this.step, data: {
            creditorPersonExists: this.creditorPersonExists, 
            creditorOrgExists: this.creditorOrgExists, 
            creditorSurvey: creditorInfo,
            creditorOrgSurvey: creditorOrgInfo,
            creditorCompleted: this.creditorCompleted}
        })       
    }

    public getCreditorResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        for(const creditor of this.creditorData)
        {
            questionResults.push({name:'creditorSurvey', value: this.getCreditorInfo(creditor), title:'Creditor '+creditor.id +' Information', inputType:''})
        }        
        
        return {data: this.creditorData, questions:questionResults, pageName:'Creditor Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getCreditorOrgResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];        

        for(const creditor of this.creditorOrgData)
        {
            questionResults.push({name:'creditorOrgSurvey', value: this.getCreditorOrgInfo(creditor), title:'Creditor Organization '+creditor.id +' Information', inputType:''})
        }
        
        return {data: this.creditorOrgData, questions:questionResults, pageName:'Creditor Organization Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getCreditorInfo(creditor){
        const resultString = [];

        resultString.push(Vue.filter('styleTitle')("Name: ")+creditor.creditorPersonName);       
        resultString.push(Vue.filter('styleTitle')("Alive: ")+(creditor.creditorPersonIsAlive=='y'?'Yes':'No'));
        if(creditor.creditorPersonIsAlive=='y' && creditor.creditorPersonIsAdult)
            resultString.push(Vue.filter('styleTitle')("Adult: ")+(creditor.creditorPersonIsAdult=='y'?'Yes':'No'));      
        
        return resultString;
    }  

    public getCreditorOrgInfo(creditor){
        const resultString = [];

        resultString.push(Vue.filter('styleTitle')("Name: ")+creditor.creditorOrganizationName);        
        
        return resultString;
    }  

    public resetCreditorRelatedPages(creditorData?) {
    //TODO
        // const stPgNo: stepsAndPagesNumberInfoType = this.$store.state.Application.stPgNo;   
        // const p = stPgNo.RFLM;

        // const pages = [ 
        //     p.ParentingArrangements,
        //     p.ParentalResponsibilities,
        //     p.ParentingTime,
        //     p.ParentingOrderAgreement,
        //     p.BestInterestsOfCreditor,
        //     p.CreditorSupportCurrentArrangements,
        //     p.AboutCreditorSupportOrder,
        //     p.SpecialAndExtraordinaryExpenses,
        //     p.ContactWithCreditor,
        //     p.ContactWithCreditorOrder,
        //     p.AboutContactWithCreditorOrder,
        //     p.ContactWithCreditorBestInterestsOfCreditor,
        //     p.GuardianOfCreditor,           
        //     p.ReviewYourAnswersRFLM
        // ]
        // Vue.filter('setProgressForPages')(p._StepNo, pages,50);    

    }
}
